/* eslint-disable no-magic-numbers */
import * as Adaptive from 'adaptivecards';

export class TextWithLimit extends Adaptive.Input {
	static labelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_6, 'label');

	static valueProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_6, 'value');

	static maxLengthProperty = new Adaptive.NumProperty(Adaptive.Versions.v1_6, 'maxLength');

	getJsonTypeName() {
		return 'Input.TextWithLimit';
	}

	get label() {
		return this.getValue(TextWithLimit.labelProperty);
	}

	set label(value) {
		this.setValue(TextWithLimit.labelProperty, value);
	}

	get value() {
		return this.getValue(TextWithLimit.valueProperty) || '';
	}

	set value(val) {
		this.setValue(TextWithLimit.valueProperty, val);
	}

	get maxLength() {
		return this.getValue(TextWithLimit.maxLengthProperty) || 5000;
	}

	parse(json, errors) {
		super.parse(json, errors);
		this.label = json.label;
		this.value = json.value || '';
		this.hideCounter = json.hideCounter || false;
	}

	isSet() {
		return this.value.length > 0;
	}

	internalRender() {
		const container = document.createElement('div');
		container.style.width = '100%';

		this.inputElement = document.createElement('textarea');
		this.inputElement.value = this.value;
		this.inputElement.maxLength = this.maxLength;
		this.inputElement.rows = 3;
		this.inputElement.style.width = '100%';
		this.inputElement.classList.add('ac-input', 'ac-textInput', 'ac-multiline');

		if (this.label) {
			this.inputElement.setAttribute('aria-label', this.label);
		}

		if (this.hideCounter) {
			this.inputElement.readOnly = true;
			container.appendChild(this.inputElement);
			return container;
		}

		this.counterElement = document.createElement('div');
		this.counterElement.classList.add('ac-textBlock', 'ac-character-counter');
		this.counterElement.setAttribute('aria-live', 'polite');

		const updateCounter = () => {
			let currentValue = this.inputElement.value;

			if (currentValue.length > this.maxLength) {
				currentValue = currentValue.slice(0, this.maxLength);
				this.inputElement.value = currentValue;
			}

			this.value = currentValue;
			this.counterElement.innerText = `${currentValue.length} / ${this.maxLength}`;
			this.valueChanged();
		};

		this.inputElement.addEventListener('input', updateCounter);

		this.counterElement.innerText = `${this.value.length} / ${this.maxLength}`;

		container.appendChild(this.inputElement);
		container.appendChild(this.counterElement);

		return container;
	}
}
